export default __webpack_public_path__ + "static/media/chain-broker.dca72d3e.png";